document.addEventListener("DOMContentLoaded", (event) => {
  let productForm = document.querySelector('product-form form');
  let propText = document.querySelector("#engrave_prop_text");
  let inputValue = "Georgia";
  let inputStyles = document.querySelectorAll(".engrave-text__styles input");
  let inputText = document.querySelector('.engrave-text__input input');
  let engravePrice = document.querySelector('.engrave_calc');
  let engrave = document.querySelector('.engrave-text');
  let currencySymbol = document.querySelector('.symbol-box').getAttribute('data-symbol');
  let keepBackground = document.getElementById('keep_background');

  const previewBaseUrl = window.routes?.apps_crystal_settings || '/apps/crystal-settings';
  let previewAbortController = undefined;
  let previewEventSource = undefined;
  let activePreviewBatchId = undefined;
  let previewRenderTimeout = undefined;
  let previewRenderFn = undefined;
  let currentVariantSku = document.querySelector('.product-variant-id')?.dataset?.sku || '';

  const livePreviewV3OwnsPdp = () => {
    if (window.DCCOMLivePreview?.disableV2) return true;
    const preview = document.querySelector('ccm-live-preview-v3[data-surface="pdp"]');
    if (!preview) return false;
    const mode = String(preview.dataset.mode || 'off').toLowerCase();
    return mode === 'on'
      || (mode === 'internal' && new URLSearchParams(window.location.search).get('preview_v3') === '1');
  };

  const cancelPreviewBatch = (batchId) => {
    if (!batchId) {
      return;
    }
    fetch(previewBaseUrl.concat(`/api/v2/previews/${batchId}/cancel`), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch(() => {});
  };

  const closePreviewStream = () => {
    if (previewEventSource) {
      previewEventSource.close();
      previewEventSource = undefined;
    }
  };

  const schedulePreviewRender = (delayMs = 5000) => {
    if (livePreviewV3OwnsPdp() || !previewRenderFn) {
      clearTimeout(previewRenderTimeout);
      return;
    }
    clearTimeout(previewRenderTimeout);
    previewRenderTimeout = setTimeout(() => {
      previewRenderFn();
    }, delayMs);
  };

  const requestPreviewRender = () => {
    if (livePreviewV3OwnsPdp() || !previewRenderFn) {
      clearTimeout(previewRenderTimeout);
      return;
    }
    clearTimeout(previewRenderTimeout);
    previewRenderFn();
  };
  
  const removeBackgroundInput = () => {
    const removeInput = document.createElement('input');
    removeInput.setAttribute('type', 'hidden');
    removeInput.setAttribute('name', 'properties[Remove Background]')
    removeInput.value = 'Yes';
    productForm.prepend(removeInput)
    keepBackground.addEventListener('change', function (event) {
      removeInput.value = this.checked ? 'No' : 'Yes';
      console.log('Remove Background', this.checked ? 'No' : 'Yes')
    })
    // `removeInput` already starts at the correct unchecked value (`Yes`). Do
    // not dispatch a synthetic change here: V3 listens during capture, so even
    // a non-bubbling setup event looks like a shopper toggle and opens the
    // photo picker on every PDP visit.
  }
  if (productForm && keepBackground) {
    removeBackgroundInput();
  }

  const updateProductIdentify = () => {
    const groupID = (Math.random() + 1).toString(36).substring(7).toUpperCase();
    document.querySelectorAll('.product-variant__hidden-group-identify').forEach((el) => {
      el.value = groupID;
    });
  };

  updateProductIdentify();
  
  document.querySelector('.product-variant-id').addEventListener('change', function () {
      updateProductIdentify();
      currentVariantSku = this.dataset.sku || currentVariantSku;
      requestPreviewRender();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.skipPreviewUpdate) {
        return;
      }
      const nextSku = event?.data?.variant?.sku;
      if (nextSku) {
        currentVariantSku = nextSku;
        const variantInput = document.querySelector('.product-variant-id');
        if (variantInput) {
          variantInput.dataset.sku = nextSku;
        }
      }
      requestPreviewRender();
    });
  }
  
  //start Engrave text
  function updatePropText() {
    let text = inputText.value;
    if (text != null && text != "") {
      text += ` (${inputValue})`;
    }
    propText.value = text;
  }

  inputText.addEventListener('input', function() {
    inputStyles.forEach(function(elem) {
      if (elem.checked) {
        inputValue = elem.value;
      }
    });
    inputText.parentNode.querySelector('span').innerText = inputText.getAttribute('maxlength') - inputText.value.trim().length;
    updatePropText();
    schedulePreviewRender();
  });

  inputStyles.forEach(function(e) {
    if (e.checked) {
      inputValue = e.value;
    }
    e.addEventListener('click', function(e) {
      inputValue = this.value;
      updatePropText();
      requestPreviewRender();
    });
  });
  updatePropText();
  inputText.addEventListener('blur', function() {
    requestPreviewRender();
  });
  //end Engrave text

// Retailer references never contribute to the amount charged or quantity savings.
function referencePriceCents(parent, quantity = 1) {
  const reference = parent.querySelector('[data-market-reference-inline], [data-dc-addon-price]:not([hidden])');
  const cents = Number(reference?.dataset.referencePriceCents);
  return Number.isFinite(cents) && cents > 0 ? cents * Number(quantity) : null;
}

function summaryReference(parent, quantity = 1) {
  const reference = parent.querySelector('[data-market-reference-inline], [data-dc-addon-price]:not([hidden])');
  const cents = referencePriceCents(parent, quantity);
  if (cents === null) return '';
  const strike = cents > Number(reference.dataset.sellingPriceCents) * Number(quantity);
  const amount = `${currencySymbol}${(cents / 100).toFixed(2)}`;
  return `<span class="dc-pdp__reference">Elsewhere ${strike ? `<s>${amount}</s>` : amount}</span>`;
}

function summaryCompareAction() {
  const selected = document.querySelector('.product-option__size input:checked')?.parentNode;
  const source = selected?.querySelector('.market-reference-row-action');
  if (!source) return '';
  const button = source.cloneNode(true);
  button.className = 'dc-pdp__compare-action';
  return button.outerHTML;
}

function syncAddonReferences() {
  const selected = document.querySelector('.product-option__size input:checked')?.parentNode;
  const references = Array.from(selected?.querySelectorAll('[data-dc-addon-reference]') || []);
  document.querySelectorAll('[data-dc-addon-price]').forEach((target) => {
    const row = target.closest('.product-form__item, .product-additional__wrapper');
    const price = Number(row?.querySelector('[option-price]')?.getAttribute('option-price') || row?.querySelector('[prod-price]')?.getAttribute('prod-price'));
    const reference = references.find((item) => item.dataset.dcAddonReference === target.dataset.dcAddonPrice
      && Number(item.dataset.validUntil) * 1000 > Date.now()
      && Number(item.dataset.sellingPriceCents) === Math.round(price * 100));
    target.hidden = !reference || price <= 0;
    target.textContent = '';
    delete target.dataset.referencePriceCents;
    if (target.hidden) return;
    target.dataset.referencePriceCents = reference.dataset.referencePriceCents;
    target.dataset.sellingPriceCents = reference.dataset.sellingPriceCents;
    target.className = 'dc-pdp__reference';
    const cents = Number(reference.dataset.referencePriceCents);
    if (!Number.isFinite(cents) || cents <= 0) { target.hidden = true; return; }
    target.append('Elsewhere ');
    const amount = document.createElement(cents > price * 100 ? 's' : 'span');
    amount.textContent = `${currencySymbol}${(cents / 100).toFixed(2)}`;
    target.append(amount);
  });
}

function calcMoney() {
  syncAddonReferences();
  const items = document.querySelectorAll('.product-option__size-wrap input[type="radio"]');
  const box = document.querySelector('.calculation_box');
  const quantity = document.querySelector('.quantity__input').value;
  const engraveInput = engrave.querySelector('input');
  let totalPriceAdd = 0;
  let elsewhereTotalCents = 0;
  let completeComparison = true;
  const includeComparison = (parent, amount, count) => {
    if (amount <= 0) return;
    const reference = referencePriceCents(parent, count);
    if (reference === null) completeComparison = false;
    else elsewhereTotalCents += reference;
  };

  box.innerHTML = '<div class="calculation__content"></div>';
  const contentBox = box.querySelector('.calculation__content');

  items.forEach((e, index) => {
    if (e.checked) {
      let price = e.parentNode.querySelector('.price-box').getAttribute('option-price') * quantity;
      includeComparison(e.parentNode, price, quantity);
      let discountPrice = price;
      let line = '';
      if(e.closest('.product-option__size')){
        discountPrice = quantity > 1 ? Math.round(price * 100 * 0.75) / 100 : price;
        line = quantity > 1 ? ' line' : '';
      };
      let quant = e.closest('.product-option__size') ? `<span class="calculation_quantity">${quantity} ${Number(quantity) === 1 ? 'crystal' : 'crystals'}</span>` : '';
      contentBox.innerHTML += `
        <div class="calculation_item" style="order:${index}">
          <div>
            <strong class="title_target">${e.parentNode.querySelector('.option_title').innerText}</strong>
            <div class="calculation_pirce-box">
              <span class="old_price_target${line}" data-old-price="${price}">${currencySymbol}${price.toFixed(2)}</span>
              <strong class="price_target" data-price="${discountPrice}">${currencySymbol}${discountPrice.toFixed(2)}</strong>
            </div>
          </div>
          ${quant}
          ${line ? '<span class="dc-pdp__reference">25% quantity discount</span>' : summaryReference(e.parentNode, quantity)}
        </div>`;
    }
  });

  if (engraveInput.value) {
    contentBox.innerHTML += `
      <div class="calculation_item" style="order:0">
        <div>
          <strong class="title_target">${engrave.querySelector('span').innerText}</strong>
          <div class="calculation_pirce-box">
            <span class="old_price_target">${engrave.querySelector('strong').innerText}</span>
            <strong class="price_target">${engrave.querySelector('strong').innerText}</strong>
          </div>
        </div>
      </div>`;
  }

  document.querySelectorAll('.product-additional__wrapper').forEach(e => {
    if (!e.classList.contains('hide')) {
      const prodPrice = e.querySelector('.product-form__buttons button').getAttribute('prod-price') * e.querySelector('.product-form__quant input').value;
      totalPriceAdd += prodPrice;
      includeComparison(e, prodPrice, Number(e.querySelector('.product-form__quant input').value));
      const quantAdd = `<span class="calculation_quantity">${e.querySelector('.product-form__quant input').value} ${Number(e.querySelector('.product-form__quant input').value) === 1 ? 'crystal' : 'crystals'}</span>`;
      contentBox.innerHTML += `
        <div class="calculation_item">
          <div>
            <strong class="title_target">${e.querySelector('.product-additional__deeper-inner h5').innerText}</strong>
            <div class="calculation_pirce-box">
              <span class="old_price_target" data-old-price="${prodPrice}">${currencySymbol}${prodPrice.toFixed(2)}</span>
              <strong class="price_target" data-price="${prodPrice}">${currencySymbol}${prodPrice.toFixed(2)}</strong>
            </div>
          </div>
          ${quantAdd}
          ${summaryReference(e, Number(e.querySelector('.product-form__quant input').value))}
        </div>`;
    }
  });
      const oldPrice = [];
      const disPrice = [];
      let oldSum = '';
      let disSum = '';
    document.querySelectorAll('.calculation__content .calculation_item').forEach(function(element){
      if(element.querySelector('span[data-old-price]')){
        oldPrice.push(parseFloat(element.querySelector('span[data-old-price]').getAttribute('data-old-price')));
        oldSum = oldPrice.reduce((partialSum, a) => partialSum + a, 0);
        disPrice.push(parseFloat(element.querySelector('strong[data-price]').getAttribute('data-price')));
        disSum = disPrice.reduce((partialSum, a) => partialSum + a, 0);
      }
    });
  
    if(oldSum){
    const quantityDiscount = oldSum > disSum;
    const elsewhereAmount = `${currencySymbol}${(elsewhereTotalCents / 100).toFixed(2)}`;
    const totalReference = !quantityDiscount && completeComparison && elsewhereTotalCents > 0
      ? `<span class="dc-pdp__total-reference" title="Sum of current typical retailer prices for the selected items. Excludes shipping, taxes and promotions.">Elsewhere total ${elsewhereTotalCents > Math.round(disSum * 100) ? `<s>${elsewhereAmount}</s>` : elsewhereAmount}</span>`
      : '';
    const compareAction = summaryCompareAction();
    document.querySelector('.calc_total').innerHTML = `
      <div class="calculation_item calculation_total">
        <div>
          <strong class="title_target">Total</strong>
          <div class="calculation_pirce-box">
            <span class="old_price_target${oldSum > disSum ? ' line' : ''}">${currencySymbol}${oldSum.toFixed(2)}</span>
            <strong class="price_target">${currencySymbol}${disSum.toFixed(2)}</strong>
          </div>
        </div>
        ${totalReference || compareAction ? `<p class="dc-pdp__total-comparison">${compareAction}${totalReference}</p>` : ''}
        ${oldSum > disSum ? `<p class="dc-pdp__savings">You save ${currencySymbol}${(oldSum - disSum).toFixed(2)} with your quantity discount</p>` : ''}
      </div>`;
    }
  document.querySelectorAll('.product-additional__wrapper').forEach(e => {
      const inputID = e.querySelector('.product-form__buttons').getAttribute('data-id');
      const inputElem = document.querySelector(`input.product-additional[data-id="${inputID}"]`);
      if(e.classList.contains('hide')){
        inputElem.value = 0;
      }else{
        inputElem.value = e.querySelector('input[type="number"]').value;
      }
  });
  let checkedBase = document.querySelector('.product-option__base input[type="radio"]:checked');
  let checkedQuarant = document.querySelector('.product-option__guarant input[type="radio"]:checked');
  if(checkedBase){
    document.querySelector('input.product-variant__hidden-base').value = checkedBase.value
    document.querySelector('input.product-variant__hidden-base-quant').value = quantity;
  };
  if(checkedQuarant){
    document.querySelector('input.product-variant__hidden-quarant').value = checkedQuarant.value
    document.querySelector('input.product-variant__hidden-quarant-quant').value = quantity;
  };

  if (document.querySelector('.product-variant-id')) {
    document.querySelector('.product-variant-id').addEventListener('change', function () {
      document.querySelector('input.product-variant__hidden-base-sku').value = this.dataset.sku;
      // document.querySelector('input.product-variant__hidden-base-id').value = this.value;
    })
  }
}

calcMoney();
document.addEventListener("change", calcMoney);
engrave.querySelector('input').addEventListener("input", calcMoney);
document.querySelectorAll('.product-additional__wrapper button[type="submit"], .product-additional__wrapper .product-form__quant button[type="button"]').forEach(e => {
  e.addEventListener('click', function() {
    this.closest('.product-additional__wrapper').classList.toggle('hide');
    if(this.closest('.product-additional__wrapper').classList.contains('hide')){
      this.parentNode.querySelector('input[type="number"]').value = 0;
    }else{
      this.parentNode.querySelector('input[type="number"]').value = 1;
    }
    calcMoney();
  });
});

//start Media Gallery
 let prodGallery = document.querySelector(".product_swiper_gallery");
 let prodWindow = document.querySelector(".product_swiper_window");
  if(prodGallery){
   var swiperGallery = new Swiper(prodGallery, {
      spaceBetween: 24,
      slidesPerView:  4,
      freeMode: true,
      watchSlidesProgress: true,
       breakpoints: {
        0: {
          spaceBetween: 16
        },
        1000: {
          spaceBetween: 24
        }
      }
    });
  }
  if(prodWindow){
    var swiperProd = new Swiper(prodWindow, {
      spaceBetween: 24,
      thumbs: {
        swiper: swiperGallery,
      },
    });
  }
//end Media Gallery

// //start Base Option slider
  let swiperBase = document.querySelector(".swiper-base");
  if(swiperBase){
   new Swiper(swiperBase, {
    slidesPerView: 'auto',
     pagination: {
      el: swiperBase.parentNode.querySelector(".swiper-pagination"),
    }
   });
  }
// //end Base Option slider

// star photoEditor
   function photoEditor(){
      const productfilepicker = document.getElementById('product-file-picker');
      const uploadedImage = document.getElementById('uploaded-image');
      const uploadedImg = document.getElementById('uploaded-img');
      const keepBack = document.getElementById('keep_background');
      let proPhoto = document.getElementById('source-photo');
      let params = new URLSearchParams(document.location.search);
      let sourcefile = params.get("sourcefile");
      let sku2 = params.get("sku");
      productfilepicker.addEventListener('click', async function (event) {
        event.preventDefault();
        try {
          const choice = await window.NativePhotoCompat.choose();
          if (choice) {
            const selected = window.NativePhotoCompat.metadata(choice);
            onUploadDone({filesUploaded:[selected]});
            onFileUploadFinished(selected.url);
          }
        } catch (error) {
          let notice = productfilepicker.parentNode.querySelector('[data-native-photo-error]');
          if (!notice) {notice=document.createElement('p');notice.dataset.nativePhotoError='true';notice.setAttribute('role','alert');productfilepicker.after(notice);}
          notice.textContent=error.message || 'Your photo could not be saved. Please retry.';
        }
      });
      function onUploadDone (result) {
        let onUploadDoneResult = result;
        (result.filesUploaded) ? onUploadDoneResult = result.filesUploaded[0].url : onUploadDoneResult = result;
        uploadedImage.classList.remove('hide');
        productfilepicker.innerText = 'Change photo';
        uploadedImg.setAttribute('src', onUploadDoneResult);
        proPhoto.setAttribute('value', onUploadDoneResult);
      };
      if(sourcefile){
        onUploadDone(sourcefile);
      }
       let optimizeSkuProduct = (sku) => {
        if (sku.length === 15 || sku.length === 16) {
          return sku;
        }
        sku = sku.replace('-CUSTOM', '').replace('-CUSTM', '');
        if (sku.includes("-")) {
          return sku.concat("-DCCOM").slice(0, 16)
        }
        return sku.concat("-A-DCCOM").slice(0, 16)
     };
     function initEditor(sourcefile,sku2){
          // V3 owns the preview image properties while it is active. Running
          // the legacy renderer here can finish later and replace the V3
          // poster/thumbnail just before a cart add or cart edit submission.
          if (livePreviewV3OwnsPdp()) {
            previewAbortController?.abort();
            closePreviewStream();
            if (activePreviewBatchId) {
              cancelPreviewBatch(activePreviewBatchId);
              activePreviewBatchId = undefined;
            }
            return;
          }
          let sku = currentVariantSku || document.querySelector('.product-variant-id')?.getAttribute('data-sku');
          if(sku2){
            sku = sku2;
            currentVariantSku = sku2;
          };
          const sourceUrl = sourcefile ? sourcefile : uploadedImg.getAttribute('src');
          if(sourceUrl){
           function removeAdded(gallery, slider){
             if (!gallery) {
               return;
             }
             const addedSlides = gallery.querySelectorAll('.swiper-slide.added');
             if(addedSlides.length > 0){
                addedSlides.forEach((e)=>{
                  e.remove();
                });
             }
             slider?.update();
           }
           removeAdded(prodGallery, swiperGallery);
           removeAdded(prodWindow, swiperProd);
          const spinner = prodWindow?.querySelector('.loading__spinner');
          spinner?.classList.remove('hidden');

          previewAbortController?.abort();
          previewAbortController = new AbortController();
          closePreviewStream();
          if (activePreviewBatchId) {
            cancelPreviewBatch(activePreviewBatchId);
            activePreviewBatchId = undefined;
          }

          const getPreviewSourceUrl = function (image_url) {
            if (!image_url) {
              return '';
            }

            let image_url_object;
            try {
              image_url_object = new URL(image_url, window.location.origin);
            } catch (error) {
              return '';
            }

            if (!['http:', 'https:'].includes(image_url_object.protocol)) {
              return '';
            }

            if (image_url_object.pathname.startsWith('/products/')) {
              return '';
            }

            const archived = window.NativePhotoCompat?.legacyUrl(image_url_object.href);
            if (archived) return archived;

            if (image_url_object.hostname === 'canopy.crystalclearmemories.com') {
              return image_url_object.href;
            }

            return /\.(avif|gif|heic|heif|jpe?g|png|webp)$/i.test(image_url_object.pathname)
              ? image_url_object.href
              : '';
          };

          const addSlides = function (gallery, slider, displayUrl){
            if (!gallery || !slider || !displayUrl) {
              return;
            }
            const baseSlide = gallery.querySelector('.swiper-slide');
            if (!baseSlide) {
              return;
            }
            const galleryItem = document.createElement("div");
            galleryItem.innerHTML = baseSlide.innerHTML;
            galleryItem.classList.add('swiper-slide','added');
            const image = galleryItem.querySelector('img');
            if (image) {
              image.removeAttribute('srcset');
              image.setAttribute('src', displayUrl);
            }
            slider.prependSlide(galleryItem);
            slider.slideTo(0);
          };

          const updatePreviewInputs = function (fullUrl, thumbUrl, mediumUrl) {
            if (livePreviewV3OwnsPdp() || !productForm) {
              return;
            }
            const formPreviewUrl = fullUrl || mediumUrl;
            if (!formPreviewUrl) {
              return;
            }
            const previewThumb = thumbUrl || formPreviewUrl;
            const previewInput = productForm.querySelector('[name="properties[_preview_image_url]"]');
            const previewThumbInput = productForm.querySelector('[name="properties[_preview_image_thumbnail_url]"]');

            if (previewInput) {
              previewInput.value = formPreviewUrl;
            } else {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'properties[_preview_image_url]';
              input.value = formPreviewUrl;
              productForm.append(input);
            }

            if (previewThumbInput) {
              previewThumbInput.value = previewThumb;
            } else {
              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'properties[_preview_image_thumbnail_url]';
              input.value = previewThumb;
              productForm.append(input);
            }
          };

          const sourceText = (inputText.value.trim().length > 0) ? inputText.value : '';
          const previewSourceUrl = getPreviewSourceUrl(sourcefile ? sourcefile : uploadedImg.getAttribute('src'));
          if (!previewSourceUrl) {
            spinner?.classList.add('hidden');
            return;
          }
          const removeBackground = keepBack ? !keepBack.checked : true;

          fetch(previewBaseUrl.concat('/api/v2/previews'), {
            method: "POST",
            signal: previewAbortController.signal,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              sku: optimizeSkuProduct(sku),
              source_image_url: previewSourceUrl,
              source_font: inputValue,
              source_text: sourceText,
              remove_background: removeBackground,
            }),
          })
          .then((response) => response.json())
          .then((batch) => {
              const items = Array.isArray(batch.items) ? batch.items : [];
              if (!items.length) {
                activePreviewBatchId = undefined;
                spinner?.classList.add('hidden');
                return;
              }
              activePreviewBatchId = batch.batch_id;
              const batchId = batch.batch_id;
              const totalItems = items.length;
              const renderedItemIds = new Set();
              const completedItemIds = new Set();

              const renderPreviewItem = function (item) {
                if (livePreviewV3OwnsPdp() || !item || !item.result_url) {
                  return;
                }
                if (item.item_id && renderedItemIds.has(item.item_id)) {
                  return;
                }
                const mediumUrl = item.medium_url || item.mediumUrl || item.medium;
                const fullUrl = item.result_url;
                const thumbUrl = item.thumbnail_url || mediumUrl || fullUrl;
                addSlides(prodGallery, swiperGallery, thumbUrl);
                addSlides(prodWindow, swiperProd, mediumUrl || fullUrl);
                updatePreviewInputs(fullUrl, thumbUrl, mediumUrl);
                if (item.item_id) {
                  renderedItemIds.add(item.item_id);
                }
                spinner?.classList.add('hidden');
              };

              const markItemComplete = function (itemId) {
                if (!itemId || completedItemIds.has(itemId)) {
                  return;
                }
                completedItemIds.add(itemId);
                if (completedItemIds.size >= totalItems) {
                  closePreviewStream();
                  activePreviewBatchId = undefined;
                }
              };

              items.forEach((item) => {
                if (item.status === 'cached' && item.result_url) {
                  renderPreviewItem(item);
                  markItemComplete(item.item_id);
                }
              });

              const pollBatch = function () {
                const startedAt = Date.now();
                const pollOnce = () => {
                  if (livePreviewV3OwnsPdp()) {
                    previewAbortController?.abort();
                    closePreviewStream();
                    if (activePreviewBatchId === batchId) {
                      cancelPreviewBatch(batchId);
                      activePreviewBatchId = undefined;
                    }
                    return;
                  }
                  if (activePreviewBatchId !== batchId) {
                    return;
                  }
                  if (Date.now() - startedAt > 45000) {
                    activePreviewBatchId = undefined;
                    spinner?.classList.add('hidden');
                    return;
                  }
                  fetch(previewBaseUrl.concat(`/api/v2/previews/${batchId}`), {
                    signal: previewAbortController.signal,
                    cache: "no-store",
                  })
                  .then((response) => response.json())
                  .then((status) => {
                    const statusItems = Array.isArray(status.items) ? status.items : [];
                    statusItems.forEach((item) => {
                      if (item.status === 'completed' || item.status === 'cached') {
                        renderPreviewItem(item);
                        markItemComplete(item.item_id);
                      } else if (item.status === 'failed' || item.status === 'cancel_requested') {
                        markItemComplete(item.item_id);
                      }
                    });
                    if (completedItemIds.size < totalItems) {
                      setTimeout(pollOnce, 5000);
                      return;
                    }
                    activePreviewBatchId = undefined;
                  })
                  .catch(() => {});
                };
                pollOnce();
              };

              const handleItemEvent = function (event) {
                if (livePreviewV3OwnsPdp()) {
                  closePreviewStream();
                  if (activePreviewBatchId === batchId) {
                    cancelPreviewBatch(batchId);
                    activePreviewBatchId = undefined;
                  }
                  return;
                }
                const data = JSON.parse(event.data || '{}');
                if (activePreviewBatchId !== batchId || !data.item_id) {
                  return;
                }
                if (data.result_url) {
                  renderPreviewItem(data);
                }
                markItemComplete(data.item_id);
              };

              if (!window.EventSource) {
                pollBatch();
                return;
              }
              previewEventSource = new EventSource(previewBaseUrl.concat(`/api/v2/previews/${batchId}/events`));
              previewEventSource.addEventListener('item.completed', handleItemEvent);
              previewEventSource.addEventListener('item.cached', handleItemEvent);
              previewEventSource.addEventListener('item.failed', (event) => {
                const data = JSON.parse(event.data || '{}');
                if (activePreviewBatchId !== batchId || !data.item_id) {
                  return;
                }
                markItemComplete(data.item_id);
              });
              previewEventSource.onerror = () => {
                closePreviewStream();
                pollBatch();
              };
          }).catch((error) => console.error(error)); 
          }
        };
      previewRenderFn = () => initEditor();
       function onFileUploadFinished(selectedUrl){
        setTimeout(() => {if (proPhoto.value === selectedUrl) initEditor();},1000);
      };
    setTimeout(initEditor,2000,sourcefile,sku2);
  }
  photoEditor();
  // Restore saved customization only after all option and pricing listeners exist.
  if (productForm) {
    productForm.dataset.dcOptionsReady = 'true';
    productForm.dispatchEvent(new CustomEvent('dc:pdp:options-ready', { bubbles: true }));
  }
  // end photoEditor
});
